<!-- SkyPlus Workflow Shell — Round 6 (May 2026).
     Pure layout chrome: header on top, sidebar on the left, router-outlet
     on the right. All dynamic concerns live inside child components.

     H.2.2.A: nav is collapsible via the toggle at the top of the sidebar.
     State persists per user in localStorage under 'sp-workflow-nav-collapsed'.
     When collapsed, the aside shrinks to 44px (toggle only); the
     spResizable directive's stored width applies again on expand. -->
<div class="sp-workflow-container">

  <!-- ==================== HEADER ==================== -->
  <sp-header></sp-header>

  <!-- ==================== MAIN CONTENT ==================== -->
  <div class="sp-workflow-main">

    <!-- ==================== LEFT SIDEBAR ==================== -->
    <aside class="sp-workflow-sidebar"
       [class.collapsed]="navCollapsed"
       spResizable
       [minWidth]="220"
       [maxWidth]="520"
       [defaultWidth]="300"
       storageKey="sp-workflow-sidebar-width">

      <!-- H.2.2.A: collapse toggle. Stays visible at the top even when
           collapsed so the user can always re-expand. -->
      <button class="sp-workflow-sidebar-toggle"
              type="button"
              (click)="toggleNav()"
              [attr.title]="navCollapsed ? 'Expand navigation' : 'Collapse navigation'"
              [attr.aria-label]="navCollapsed ? 'Expand navigation' : 'Collapse navigation'">
        <span class="material-icons">
          {{ navCollapsed ? 'chevron_right' : 'chevron_left' }}
        </span>
      </button>

      <!-- Sidebar content — hidden via CSS when collapsed. The component
           stays mounted so its menu state survives a collapse/expand
           cycle (no menu refetch). -->
      <div class="sp-workflow-sidebar-content">
        <app-workflow-sidebar></app-workflow-sidebar>
      </div>
    </aside>

    <!-- ==================== CENTER CONTENT (route-driven) ==================== -->
    <main class="sp-workflow-content">
      <router-outlet></router-outlet>
    </main>

  </div>

</div>